import { Component, Prop } from 'vue-property-decorator'
import router from '@/_router'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import WidgetTemplate from '@/views/Project/Dashboard/components/widget.vue'
import EditorViewer from '@/components/EditorViewer/EditorViewer.vue'

@Component({
    name: 'HSEInfoWidget',
    mixins: [ProjectMixin],
    components: { WidgetTemplate, EditorViewer },
})
export default class HSEInfoWidget extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop({ required: true }) component!: any
    @Prop({ required: true }) dashboardId!: string

    get project() {
        return this.projectId ? this.$store.getters.project(this.projectId) : null
    }

    get projectId() {
        return this.dashboardViewType
            ? this.component?.settings[this.dashboardViewType].project
                ? this.component?.settings[this.dashboardViewType].project
                : this.component?.settings.default.project
            : null
    }

    set projectId(data) {
        this.component.settings[this.viewType].project = data
        let widgets = JSON.parse(JSON.stringify(this.$store.getters.widgetsData))
        let widget = widgets[this.component.id]
        widget.settings[this.viewType].project = data
        this.$store.commit('widgetsData', widgets)
    }

    get projects(): Array<any> {
        return Object.values(this.$store.getters.projects).filter((project: any) => {
            return this.hasPermission(project.attributes.permissions, 'view_hse_info')
        })
    }

    get HSEDescription() {
        return this.projectId
            ? this.$store.getters.project(this.projectId)?.attributes.hseBoardDescription
            : null
    }

    navigateToSettings() {
        router.push({
            name: 'hse-info-settings',
            query: { ...(this.projectId && { projectId: this.projectId }) },
        })
    }
}
